module.exports = __webpack_public_path__ + "img/72.4c23fc10.jpg";